import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad händer om jag blir underkänd på kunskapsprovet?";
const SHORT_ANSWER = "Du får göra ett omprov inom samma ansökan. Underkänns du även där måste du lämna in en ny ansökan.";

export const Route = createFileRoute("/fraga/vad-hander-om-jag-blir-underkand")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad händer om jag blir underkänd på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Många kommuner kräver väntetid på 2–4 veckor mellan försöken. Ny ansökan innebär att hela handläggningen börjar om och avgifter tas ut på nytt."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/underkand-pa-kunskapsprovet", label: "Underkänd på provet – komplett guide" }}
      related={[{"to": "/fraga/var-bokar-jag-provet", "label": "Var bokar jag kunskapsprovet?"}, {"to": "/fraga/far-jag-gora-provet-pa-engelska", "label": "Får jag göra kunskapsprovet på engelska?"}, {"to": "/fraga/hur-manga-forsok-har-jag", "label": "Hur många försök har jag på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad händer om jag blir underkänd på kunskapsprovet?" },
      { name: "description", content: "Du får göra ett omprov inom samma ansökan. Underkänns du även där måste du lämna in en ny ansökan." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-hander-om-jag-blir-underkand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-hander-om-jag-blir-underkand" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-hander-om-jag-blir-underkand",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad händer om jag blir underkänd på kunskapsprovet", url: "https://alkoholprovet.se/fraga/vad-hander-om-jag-blir-underkand" },
      ]),
    ],
  }),
});
